import { Footer } from "@/helpers/header";
import { AdminLogin } from "@/login";
import { ConfigContext } from "@/state/configContext";
import { AdminContext } from "@/state/adminContext";
import { clearFlashMessage, useFlashMessage } from "@/state/flash";
import { mustLoginError, useAdminStatus, useConfig } from "@/state/server";
import {
  Outlet,
  createFileRoute,
  useLocation,
  useRouter,
} from "@tanstack/react-router";
import { useEffect, useRef, type ReactNode } from "react";
import { AdminHeader } from "@/admin/adminHeader";

export const Route = createFileRoute("/admin")({
  component: AdminLayoutComponent,
  errorComponent: ErrorComponent,
});

function AdminLayoutComponent() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function ErrorComponent({ error }: { error: unknown }) {
  if (error) console.log("Error", error);
  return (
    <Layout>
      {error == mustLoginError ? (
        <AdminLogin />
      ) : (
        <div>ERROR: {JSON.stringify(error)}</div>
      )}
    </Layout>
  );
}

function Layout({ children }: { children: ReactNode }) {
  const config = useConfig();
  const adminStatus = useAdminStatus();

  const flash = useFlashMessage();

  const location = useLocation();
  const prevPath = useRef(location.pathname);
  const prevFlash = useRef<unknown>(null);

  const router = useRouter();
  const logged = adminStatus.isLoading || !!adminStatus.data?.admin.id;

  useEffect(() => {
    if (!logged && location.pathname != "/admin/login") {
      router.navigate({ to: "/admin/login", replace: true });
    }
  }, [logged, location.pathname]);

  useEffect(() => {
    if (prevPath.current !== location.pathname && prevFlash.current == flash) {
      clearFlashMessage();
    }
    prevPath.current = location.pathname;
    prevFlash.current = flash;
  }, [location.pathname, flash]);

  return (
    <>
      <link href="/css/bootstrap.min.css" rel="stylesheet" />
      <link href="/css/fotronica.css" rel="stylesheet" />
      <div className="admin">
        {config.data && adminStatus.data ? (
          <ConfigContext value={config.data}>
            <AdminContext value={adminStatus.data}>
              <AdminHeader />
              {flash && (
                <div className={`alert alert-${flash.level}`}>
                  {flash.message.split("<br>").map((l) => (
                    <div>{l}</div>
                  ))}
                </div>
              )}
              <div className="container main">
                {children} <Footer />
              </div>
            </AdminContext>
          </ConfigContext>
        ) : (
          "Loading..."
        )}
      </div>
    </>
  );
}
